import { ref, computed } from 'vue';
import axios from 'axios';

/**
 * Fetches the admin-configured homepage sections (Homepage Builder feature)
 * for the public site. `header`/`footer` are global chrome (rendered once in
 * App.vue/navbar.vue, not part of index.vue's per-page section loop) — use
 * getSection('header')/getSection('footer') for those instead of
 * visibleSections. Mirrors useTestimonials()'s plain ref+fetch shape.
 */
export function useHomepageSections() {
  const sections = ref([]);
  const loading = ref(true);
  const error = ref(null);

  const visibleSections = computed(() =>
    sections.value
      .filter((s) => s.is_active && s.type !== 'header' && s.type !== 'footer')
      .slice()
      .sort((a, b) => a.sort_order - b.sort_order)
  );

  function getSection(key) {
    return sections.value.find((s) => s.key === key) || null;
  }

  async function fetchHomepageSections() {
    try {
      loading.value = true;
      error.value = null;
      const res = await axios.get('/web/homepage-sections');
      sections.value = res.data?.data || [];
    } catch (e) {
      error.value = e;
      sections.value = [];
    } finally {
      loading.value = false;
    }
  }

  return {
    sections,
    visibleSections,
    loading,
    error,
    getSection,
    fetchHomepageSections,
  };
}
